import "./styles.css";
export default function Nav() {
  return (
    <div className="titlebar">
      <nav className="navbar">
        <div className="container-fluid">
          <span>Todo App</span>
        </div>
      </nav>
    </div>
  );
}
